// All content fetched verbatim from westspringsoptometry.com — do not invent claims/prices.

export const LINKS = {
  bookOnline: "https://booking.opto.com/hvlvrw8gaxt1n/west-springs-optometry/visittype/",
  bookOnlineHref: "http://www.westspringsoptometry.com/book-online",
  orderContacts: "https://westspringsoptometry.ottooptics.io/reorder",
  instagram: "https://www.instagram.com/westspringsoptometry/",
  tiktok: "https://www.tiktok.com/@westspringsoptometry",
  facebook: "https://www.facebook.com/profile.php?id=61586223554387",
};

export const BRANDS_INTRO =
  "Discover our extensive selection of eyewear — everyday brands such as Oakley and Ray-Ban alongside exclusive premium options from Lindberg, Prada, and Saint Laurent. Whether you're after stylish sunglasses or the lightest of frames, there's something for every taste.";

export const ALL_BRANDS = [
  "Lindberg",
  "Saint Laurent",
  "Gucci",
  "Prada",
  "Miu Miu",
  "Ray-Ban",
  "Oakley",
  "Maui Jim",
  "Carrera",
  "Hugo Boss",
  "Marc Jacobs",
  "Tiffany & Co.",
  "Vogue Eyewear",
  "Zeal Optics",
  "Superflex",
];

export const CONTACT = {
  phone: "(403) 546-4513",
  phoneHref: "tel:+14035464513",
  email: "info@westspringsoptometry.com",
  addressLine1: "#1125, 930 85th St SW",
  addressLine2: "Calgary, AB T3B 6N3",
  mapQuery: "West Springs Optometry, 930 85 St SW #1125, Calgary, AB T3B 6N3",
  mapLat: 51.0584766,
  mapLng: -114.2104126,
};

export const HOURS = [
  { day: "Mon – Fri", time: "9:00 AM – 5:00 PM" },
  { day: "Saturday", time: "9:00 AM – 3:00 PM" },
  { day: "Sunday", time: "Closed" },
];

export const MISSION =
  "Our mission is to provide exceptional, patient-centered eye care in a welcoming and modern environment — enhancing the vision and eye health of our community through comprehensive exams, advanced technology, and personalized treatment plans tailored to each individual.";

export const TEAM_INTRO =
  "Our dedicated and skilled team is here to complement your unique style. We understand that everyone has their own preferences, and we strive to meet your needs with personalized attention and care. Your satisfaction is our top priority, and we look forward to helping you express your individuality.";

export const TEAM = [
  {
    name: "Dr. Nibal Elsaghir",
    role: "Optometrist",
    img: "https://static.wixstatic.com/media/ce876c_3c36b81db27c4dfba291649013c5f0ee~mv2.png/v1/crop/x_203,y_0,w_860,h_860/fill/w_521,h_521,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Nibal_edited_edited_edited_edited_edited.png",
    initials: "NE",
    bioParagraphs: [
      "Dr. Elsaghir was born and raised in Calgary, Alberta. She completed her undergraduate studies in Biological Sciences at the University of Calgary before earning early acceptance into the Pacific University College of Optometry in Forest Grove, Oregon. In 2013, she graduated with a Doctor of Optometry degree and a Bachelor of Vision Science.",
      "During her optometric training, Dr. Elsaghir completed a six-month externship at the prestigious Bascom Palmer Eye Institute in Miami, Florida, where she gained extensive experience in the diagnosis and management of ocular disease. A meaningful highlight of her education was participating in international outreach initiatives in El Salvador and Belize, delivering essential eye care to underserved communities.",
      "In clinical practice, Dr. Elsaghir enjoys caring for patients of all ages, with particular interests in pediatric optometry and ocular disease management. She is committed to thorough, comprehensive eye examinations and ensuring her patients are well-informed about their ocular health. She is fluent in Arabic and can also conduct eye examinations in basic Spanish.",
      "In her free time, Dr. Elsaghir enjoys spending quality time with her family, exploring new culinary experiences, and keeping up with her two young children. With 13 years of experience in the optical field, she is proud to provide quality comprehensive eye care for patients of all ages — and is currently accepting new patients.",
    ],
  },
];

const LOGO_BASE = "https://static.wixstatic.com/media/";
const mkLogo = (id, file, name) => ({ name, url: `${LOGO_BASE}${id}` });

export const LOGOS = [
  mkLogo("ce876c_95dc3561926d4dbe80f9722fc8f858d3~mv2.png", "lindberg-logo-png_seeklogo-360798.png", "Lindberg"),
  mkLogo("ce876c_45b6cefe71e145cc9c98dcca4e2ef9f4~mv2.png", "yves-saint-laurent-logo-png_seeklogo-197579.png", "Saint Laurent"),
  mkLogo("ce876c_8e344388c37f4211b7b69142a7fe7ffd~mv2.png", "gucci-logo-png_seeklogo-64070.png", "Gucci"),
  mkLogo("ce876c_662abbd97e78477caad387a62ee71604~mv2.png", "prada-logo-png_seeklogo-111420.png", "Prada"),
  mkLogo("ce876c_751244fbb12e40d08f5ca609c1b9c6c1~mv2.png", "miu-miu-logo-png_seeklogo-378268.png", "Miu Miu"),
  mkLogo("ce876c_3e6217cac94b422fba5b4e10b2eeb6df~mv2.png", "ray-ban-logo-png_seeklogo-116048.png", "Ray-Ban"),
  mkLogo("ce876c_5792edaf5fdc4953b913d7cbbf1f5904~mv2.png", "oakley-logo-png_seeklogo-201503.png", "Oakley"),
  mkLogo("ce876c_c14764d733184186b3da00dffad8de2e~mv2.png", "maui-jim-logo-png_seeklogo-260007.png", "Maui Jim"),
  mkLogo("ce876c_bc7ac3983c684c199c900d6644bc38a9~mv2.png", "carrera-logo-png_seeklogo-333433.png", "Carrera"),
  mkLogo("ce876c_2a8bd9dd871f4d968c27dfa5fbbbbc32~mv2.png", "hugo-boss-logo-png_seeklogo-426229.png", "Hugo Boss"),
  mkLogo("ce876c_b630deec534949578920fac244c36f0c~mv2.png", "marc-jacobs-logo-png_seeklogo-196106.png", "Marc Jacobs"),
  mkLogo("ce876c_d503d0340abb41d595b97bfe39a5e84b~mv2.png", "tiffany-co-logo-png_seeklogo-139923.png", "Tiffany & Co."),
];

export const IMAGES = {
  iris: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/2f7097dcf832f3614bb4895037236281dc2bdd6596e4cdbfd2c958f7cb0b6987.png",
  lens: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/a11ff059c1e9cb41987466a0a7dbcedd8974375eb35dd592a776befce01fbe55.png",
  retina: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/487684dcc5feadf3b6cba1dd202214ff6cf151922b5cc5e64e74331a501adcc5.png",
  octLayers: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/a1fe6d88406e64aba4de9428c8122d12005bd9db30fefda01832dc67822ddb0d.png",
  titanium: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/50ed713da538a03b602503a57b3fb8ce56e24620bdd07a05d73b737c6f91e544.png",
  ysl: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/8c86c2eab1dc0d70d1b9324dd9bd277c0d0bfda89afbeeb22afcb58db45943c5.png",
  gucci: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/e7e2421da1bd4bde74d1472883d3a0f999347b1a83dd41ff8248ed091d3e1234.png",
  miumiu: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/08f1f2536adbf7224a6c922e5eaacf64f555c530297d507bb8467a3952306373.png",
  prada: "https://static.prod-images.emergentagent.com/jobs/bac005f8-2c20-46ee-8ece-802e83d7e745/images/a52167c27545db923062b344a7b414626f2d3baf1ffabea1e52168269224f98b.png",
};

export const SERVICES = [
  {
    n: "01",
    title: "Adult Eye Exam",
    detail:
      "Comprehensive eye exam for ages 19–64 including digital wide-field imaging with Optomap and 3D OCT ultrasound-like imaging scan of the back of the eye (retina).",
    price: "$155",
  },
  {
    n: "02",
    title: "Adult Eye Exam + Contact Lens Assessment",
    detail: "Comprehensive adult eye exam plus a contact lens fitting and assessment.",
    price: "Starting at $175 and up",
  },
  {
    n: "03",
    title: "Senior Eye Exam (65+)",
    detail:
      "Comprehensive eye exam for ages 65+ including digital wide-field imaging with Optomap and 3D OCT ultrasound-like imaging scan of the back of the eye.",
    price: "$40 Copay",
  },
  {
    n: "04",
    title: "Child Eye Exam · Under 5",
    detail: "Comprehensive health and vision assessment for children under the age of 5.",
    price: "Covered by Alberta Health Care",
  },
  {
    n: "05",
    title: "Child Eye Exam · 6–18 Years",
    detail:
      "Comprehensive vision/health assessment for ages 6–18. Includes digital wide-field imaging with Optomap and 3D OCT + myopia risk/progression evaluation.",
    price: "$30 Copay",
    note: "Contact Lens Assessment: starts at $20 and up",
  },
];

export const BRANDS = [
  {
    name: "Lindberg",
    img: IMAGES.titanium,
    desc: "A Danish luxury brand that provides the ultimate design, comfort, and individuality through their signature titanium material to create stylish and beautiful eyewear.",
  },
  {
    name: "Saint Laurent",
    img: IMAGES.ysl,
    desc: "Saint Laurent Eyewear is a timeless collection of style and contemporary luxury.",
  },
  {
    name: "Gucci",
    img: IMAGES.gucci,
    desc: "One of the world's leading luxury brands. Their collections effortlessly blend cutting-edge style with classic silhouettes.",
  },
  {
    name: "Miu Miu",
    img: IMAGES.miumiu,
    desc: "Miu Miu Eyewear exudes elegance, design, and style.",
  },
  {
    name: "Prada",
    img: IMAGES.prada,
    desc: "An innovative luxury brand that creates timeless but boldly stylish eyewear.",
  },
];
